module.exports = __webpack_public_path__ + "assets/img/icon_fmly.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/family-plan/assets/images/icon_fmly.png
// module id = 13
// module chunks = 0